import React from "react";

interface HeaderProps {
  selectedYear: number;
}

const Header: React.FC<HeaderProps> = ({ selectedYear }) => {
  return (
    <div>
      <h2 className="text-lg font-bold">{selectedYear} Order Analytics</h2>
      <p className="text-sm text-gray-500">Monthly order trends</p>
    </div>
  );
};

export default Header;